var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg50N(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 221,
    viewBox: "0 0 263 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.654 130.795C119.654 130.795 184.565 134.303 213.354 125.943C242.143 117.583 242.102 74.1972 213.354 63.5022C184.606 52.8072 174.781 91.0351 174.781 91.0351",
    stroke: "#D0D0D0",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.202 56.0927C8.202 56.0927 69.6315 77.3567 99.6096 77.2558C129.588 77.155 155.142 51.273 130.455 33.0683C105.769 14.8636 72.1528 33.068 72.1528 33.068",
    stroke: "#D0D0D0",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 177.656C8 177.656 105.569 168.841 148.582 177.656C191.595 186.471 177.899 211.756 157.514 212.917C137.129 214.078 118.314 200.679 118.314 200.679",
    stroke: "#D0D0D0",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.668 177.591H254.46",
    stroke: "#D0D0D0",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.689 131.373H77.481",
    stroke: "#D0D0D0",
    strokeWidth: 16,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg50N);
export default __webpack_public_path__ + "static/media/50n.577d379e812e5e34f0ce88f68b89d175.svg";
export { ForwardRef as ReactComponent };